import React, {Component} from 'react'
import SKCountResults from "./sps/SKCountResults"
import SKRemainJobs from "./sps/SKRemainJobs"

class SearchKeywordStatistic extends Component {
    render() {
        return (
            <div className="SearchKeywordStatistic col-md-3 col-12">
                <h4>Graph search statistics</h4>
                <SKCountResults/>
                <SKRemainJobs/>
            </div>
        )
    }
}

export default SearchKeywordStatistic



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/SearchKeywordStatistic.js